/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import API from '../../../api/api';
import { getTokenData } from 'src/utils/api';
import { LOADING_STATUSES } from "src/constants/statuses";
import { isResponseSuccess } from "src/utils/api";

export const loadDashboardUsers = createAsyncThunk(
  'dashboard/loadDashboard',
  async (data, {
    getState,
    rejectWithValue,
  }) => {
    try {
      const { page, per } = getState().dashboardReducer.users;
      const response = await API(getTokenData()).USERS.load({
        created_at: moment().format('YYYY-MM-DD'),
        sort_by: 'last_login',
        page: page + 1,
        per,
      });
      if (isResponseSuccess(response.status)) {
        return {
          data: response.data || [],
          totalItems: response.total || 0,
        };
      }
      return {};
    } catch (error) {
      return rejectWithValue(error.toString);
    }
  },
);

export const loadDashboardClicks = createAsyncThunk(
  'dashboard/loadDashboardClicks',
  async (data, {
    getState,
    rejectWithValue,
  }) => {
    try {
      const { filters } = getState().dashboardReducer.clicks;
      const response = await API(getTokenData(getState)).DASHBOARD.clicks({
        ...filters,
      });
      if (isResponseSuccess(response.status)) {
        return {
          data: response.data || [],
          totalItems: response.total || 0,
        };
      }
      return {};
    } catch (error) {
      return rejectWithValue(error.toString);
    }
  },
);

const initialState = {
  users: {
    entity: [],
    page: 0,
    per: 100,
    totalItems: 0,
    status: LOADING_STATUSES.IDLE,
    error: null,
  },
  clicks: {
    entity: [],
    filters: {
      date_from: moment().subtract(14, 'days').format('YYYY-MM-DD'),
      date_to: moment().format('YYYY-MM-DD'),
    },
    status: LOADING_STATUSES.IDLE,
    error: null,
  },
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    resetDashboard: (state) => {
      state = initialState;
    },
    setClicksFilters: (state, action) => {
      state.clicks.filters = action.payload;
    },
    setUsersPageData: (state, action) => {
      state.users.page = action.payload.page;
      state.users.per = action.payload.per;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadDashboardUsers.pending, (state) => {
        state.users.status = LOADING_STATUSES.LOADING;
      })
      .addCase(loadDashboardUsers.fulfilled, (state, action) => {
        state.users.entity = action.payload?.data || [];
        state.users.totalItems = action.payload?.totalItems || 0;
        state.users.status = LOADING_STATUSES.SUCCEEDED;
      })
      .addCase(loadDashboardUsers.rejected, (state) => {
        state.users.status = LOADING_STATUSES.FAILED;
      })
      .addCase(loadDashboardClicks.pending, (state) => {
        state.clicks.status = LOADING_STATUSES.LOADING;
      })
      .addCase(loadDashboardClicks.fulfilled, (state, action) => {
        state.clicks.entity = action.payload?.data || [];
        state.clicks.totalItems = action.payload?.totalItems || 0;
        state.clicks.status = LOADING_STATUSES.SUCCEEDED;
      })
      .addCase(loadDashboardClicks.rejected, (state) => {
        state.clicks.status = LOADING_STATUSES.FAILED;
      });
  },
});

export const {
  resetDashboard,
  setClicksFilters,
  setUsersPageData,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;

export const dashboardChangePageAction = createAsyncThunk(
  'dashboard/dashboardChangePageAction',
  async ({
    page = 0,
    per = 0,
  }, {
    dispatch,
    rejectWithValue,
  }) => {
    try {
      await dispatch(setUsersPageData({
        page,
        per,
      }));
      await dispatch(loadDashboardUsers());
      return {};
    } catch (error) {
      return rejectWithValue(error.toString);
    }
  },
);
